'use strict';

const baseURL = window.location.hostname === 'localhost'
    ? 'http://localhost:3000/api/guests'
    : `${process.env.API_URL}/guests`;

export const guests = (() => {
    const getGuests = async () => {
        try {
            const response = await fetch(`${baseURL}`);
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            const resultat = await response.json();
            return resultat;
        } catch (error) {
            console.error('Error fetching guests:', error);
            return [];
        }
    };

    const getComesWithGuests = async (guestName) => {
        try {
            const guests = await getGuests();
            const guest = guests.find(g => g.name.toLowerCase() === guestName.trim().toLowerCase());
            if (guest) {
                if (guest.comeswith.length > 0) {
                    const associatedGuests = await Promise.all(guest.comeswith.map(async (id) => {
                        return guests.find(g => g.id === id) || null;
                    }));

                    return [guest, ...associatedGuests.filter(guest => guest !== null)];
                } else {
                    return [guest];
                }
            }
            return [];
        } catch (error) {
            console.error('Error getting comes with guests:', error);
            return [];
        }
    };

    const editGuestList = async (guestsToUpdate) => {
        try {
            const response = await fetch(`${baseURL}/updateguest`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ guestsToUpdate }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            const result = await response.json();
            console.log('Guest updated:', result);
            return true;
        } catch (error) {
            console.error('Error updating guest:', error);
            return false;
        }
    };

    return {
        getGuests,
        getComesWithGuests,
        editGuestList,
    };
})();
